import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useGetCompanyTemplates = () => {
    const intl = useIntl();
    return useQuery([SettingsQueryKey.CompanyTemplates], () => api.base
        .get('/api/Template/Company/')
        .then(res => res.data), {
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
